import { render, staticRenderFns } from "./StoreCard.vue?vue&type=template&id=0ffd6fb2"
import script from "./StoreCard.vue?vue&type=script&lang=js"
export * from "./StoreCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports